import { Record } from 'immutable';

export default class BasicSchemaItem extends Record({
  id: undefined,
  from: undefined,
  to: undefined,
  day: undefined,
  dayOff: undefined,
}) {
}
